import PropTypes from 'prop-types';
import React from 'react';
import {Box} from '@mui/material';

import NoPreview from './thumbnail-no-preview.jsx';

const ThumbnailImage = ({altText, src, errorSize, ...props}) => {
  if (src) {
    return (
      <Box
        component="img"
        src={src}
        draggable={false}
        alt={altText || ''}
        width="100%"
        height="auto"
        {...props}
      />
    );
  }
  return <NoPreview errorSize={errorSize} {...props} />;
};

ThumbnailImage.propTypes = {
  altText: PropTypes.string,
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  errorSize: PropTypes.string,
  sx: PropTypes.object,
};

export default ThumbnailImage;
